




































































































import 'reflect-metadata'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'

@Component
export default class DropDownManageUnitMulitiple extends Vue { 
    @Prop() public unitLists: any
    @Prop() public changeState: any

    isUnitType = true
    unitSelectType = "unitAll"
    unitFrom = null as any
    unitTo = null as any
    unitSelected = null as any

	@Watch('unitLists')
    onChildChanged(val: any[], oldVal: string) {
        if (val.length > 0) {
            this.isUnitType = false
            this.updateUnitList()
        } else {
            this.isUnitType = true
        }
    }

    async updateUnitList () {
        this.unitSelectType = "unitAll"
        this.unitFrom = null
        this.unitTo = null
        this.unitSelected = null
        this.changeState("unitSelectType", "unitAll")
        this.changeState("unitFrom", "")
        this.changeState("unitTo", "")
        this.changeState("unitSelected", [])
    }

    updateStateUnitSelectType () {
        this.changeState("unitSelectType", this.unitSelectType)
    }

    updateStateUnitFrom () {
        const unitFrom = this.unitFrom === null ? "" : this.unitFrom.code
        this.changeState("unitFrom", unitFrom)
	}

    updateStateUnitTo () {
        const unitTo = this.unitTo === null ? "" : this.unitTo.code
        this.changeState("unitTo", unitTo)
	}

    updateStateUnitSelected () {
        const unitSelected = this.unitSelected === null ? [] : this.unitSelected
        const unitIdLists = unitSelected.map((x: any) => x.id)
        this.changeState("unitSelected", unitIdLists)
	}

}
